import { AssetSvg as e } from "../assets/AssetSvg.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/button/ButtonSpinner.tsx
function n({ size: n }) {
	return /* @__PURE__ */ t(e, {
		width: n,
		height: n,
		viewBox: "0 0 24 24",
		fill: "none",
		"data-icon": "inline-start",
		className: "pf-control-spinner pf:flex-none pf:animate-[pf-control-spin_1s_linear_infinite]",
		children: /* @__PURE__ */ t("circle", {
			cx: "12",
			cy: "12",
			r: "9",
			pathLength: "100",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeDasharray: "80 20"
		})
	});
}
//#endregion
export { n as ButtonSpinner };
